"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    RecipientCacheHitIndex: {
        datapoint: {
            name: 'RecipientCacheHitIndex',
            customData: function (hitIndex) { return [Math.ceil(hitIndex / 50)]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-cache/lib/datapoints.js
// module id = 2677
// module chunks = 2 3 4 15 45 63 68